import { Error } from '../../../../../../ErrorHandling';
import { Link, Resource } from '../../../../../../Resource/Types';
import { StringOption } from '../../../../../Options/Types';

export interface InvitationsOptions {
  invitationStatus: StringOption[];
  invitationType: StringOption[];
  userGroups: StringOption[];
  accessStatus: StringOption[];
  sendDate: StringOption[];
}

export type InvitationsOptionsResource = Resource<InvitationsOptions>;

interface Waiting {
  kind: 'waiting';
}

interface Loading {
  kind: 'loading';
  links: ReadonlyArray<Link>;
}

interface Ready {
  kind: 'ready';
  resource: InvitationsOptionsResource;
}

export const waiting = (): Waiting => ({
  kind: 'waiting',
});

export const loading = (links: ReadonlyArray<Link>): Loading => ({
  kind: 'loading',
  links,
});

export const ready = (resource: InvitationsOptionsResource): Ready => ({
  kind: 'ready',
  resource,
});

export type State = Waiting | Loading | Ready | Error;
